import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changePassword } from "../../redux/actions/admin/CandidateActions";
import { CircularProgress } from "@material-ui/core";
import CustomAlert from "../shared/views/CustomAlert";
import "moment/locale/fr";
import localStorageService from "../../services/localStorageService";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import siteService from "../../services/siteService";

const useStyles = makeStyles((theme) =>
  createStyles({
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
    },
  })
);

let CandidateChangePassword = (props) => {
  const descriptionHtmlEditor = useRef();
  const { changePassword } = props;

  const classes = useStyles();

  const currentSite = siteService.getCurrentSite();
  const [hasMissingValue, setHasMissingValue] = React.useState(true);
  const [areNotSame, setAreNotSame] = React.useState(false);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [changed, setChanged] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const [changePasswordRequest, setChangePasswordRequest] = React.useState({
    id: "",
    currentPassword: "",
    newPassword: "",
    newPasswordConfirmation: "",
  });

  useEffect(() => {
    let match = props.match;
    if (match !== undefined) {
      let params = match.params;
      if (params !== undefined && params.t !== undefined) {
        setChangePasswordRequest((prevState) => {
          return { ...prevState, id: params.t };
        });
      }
    }
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setChangePasswordRequest((prevState) => {
        return { ...prevState, id: candidate?.id };
      });
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      changePasswordRequest.newPassword == "" ||
      changePasswordRequest.newPassword === undefined ||
      changePasswordRequest.newPasswordConfirmation == "" ||
      changePasswordRequest.newPasswordConfirmation === undefined ||
      changePasswordRequest.currentPassword == "" ||
      changePasswordRequest.currentPassword === undefined
    ) {
      setHasMissingValue(true);
    } else {
      setHasMissingValue(false);
    }
  }, [changePasswordRequest]);

  const handleSubmit = () => {
    setIsUpdating(true);
    changePassword(changePasswordRequest).then((data) => {
      if (data) {
        setAlertMessage(
          "<strong>Félicitations!</strong> votre mot de passe a été changé avec succès."
        );
        setAlertType("alert-success");
        setChangePasswordRequest({
          id: "",
          currentPassword: "",
          newPassword: "",
          newPasswordConfirmation: "",
        });
      } else {
        setAlertMessage("L'ancien mot de passe est incorrect.");
        setAlertType("alert-danger");
      }
      setChanged(true);
      setIsUpdating(false);
    });
  };

  return (
    <React.Fragment>
      <div className="col-lg-8">
        <div className="row">
          {/* Informations de base */}
          <div className="col-lg-12">
            <div className="bg-light-3 p-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title">
                    <h2 className="title">
                      <span>Changer le mot de passe</span>
                    </h2>
                    {/* <p></p> */}
                  </div>
                </div>
              </div>
              <div _lpchecked="1">
                <div className="form-row">
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label>Ancien mot de passe *</label>
                      <input
                        value={changePasswordRequest?.currentPassword}
                        type="password"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setChangePasswordRequest((prevState) => {
                            return { ...prevState, currentPassword: val };
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label>Nouveau mot de passe *</label>
                      <input
                        value={changePasswordRequest?.newPassword}
                        type="password"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          if (
                            changePasswordRequest.newPasswordConfirmation !=
                              "" &&
                            changePasswordRequest.conformPassword != undefined
                          ) {
                            setAreNotSame(
                              changePasswordRequest.newPasswordConfirmation.normalize() !==
                                val.normalize()
                            );
                          }
                          setChangePasswordRequest((prevState) => {
                            return { ...prevState, newPassword: val };
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label> Confirmer le nouveau mot de passe *</label>
                      <input
                        value={changePasswordRequest?.newPasswordConfirmation}
                        type="password"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setAreNotSame(
                            changePasswordRequest.newPassword.normalize() !==
                              val.normalize()
                          );
                          setChangePasswordRequest((prevState) => {
                            return {
                              ...prevState,
                              newPasswordConfirmation: val,
                            };
                          });
                        }}
                      />
                      {areNotSame && (
                        <div style={{ color: "red", marginTop: "8px" }}>
                          Les deux mots de passe sont différents.
                        </div>
                      )}
                    </div>
                    <div className="col-12 mt-4">
                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={isUpdating || hasMissingValue || areNotSame}
                      >
                        Soumettre &nbsp;{" "}
                        {isUpdating ? (
                          <CircularProgress size={15} />
                        ) : (
                          <span></span>
                        )}
                      </button>
                    </div>
                    {changed && (
                      <div className="col-12 mt-4">
                        <CustomAlert content={alertMessage} type={alertType} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

CandidateChangePassword.propTypes = {
  changePassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  changePassword: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  changePassword,
})(CandidateChangePassword);
